import { FILTER_URL } from "@/utils/request.js";
import { ElMessageBox } from "element-plus";
/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */
// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time
        .replace(new RegExp(/-/gm), "/")
        .replace("T", " ")
        .replace(new RegExp(/\.[\d]{3}/gm), "");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params =
    typeof search.params === "object" &&
    search.params !== null &&
    !Array.isArray(search.params)
      ? search.params
      : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof propName === "undefined") {
    search.params["beginTime"] = dateRange[0];
    search.params["endTime"] = dateRange[1];
  } else {
    search.params["begin" + propName] = dateRange[0];
    search.params["end" + propName] = dateRange[1];
  }
  return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].value == "" + value) {
      actions.push(datas[key].label);
      return true;
    }
  });
  if (actions.length === 0) {
    actions.push(value);
  }
  return actions.join("");
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    var match = false;
    Object.keys(datas).some((key) => {
      if (datas[key].value == "" + temp[val]) {
        actions.push(datas[key].label + currentSeparator);
        match = true;
      }
    });
    if (!match) {
      actions.push(temp[val] + currentSeparator);
    }
  });
  return actions.join("").substring(0, actions.join("").length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments,
    flag = true,
    i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === "undefined") {
      flag = false;
      return "";
    }
    return arg;
  });
  return flag ? str : "";
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== "" &&
            typeof value[key] !== "undefined"
          ) {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

// 返回项目路径
export function getNormalPath(p) {
  if (p.length === 0 || !p || p == "undefined") {
    return p;
  }
  let res = p.replace("//", "/");
  if (res[res.length - 1] === "/") {
    return res.slice(0, res.length - 1);
  }
  return res;
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}

/**
 * 获取视频封面
 * @param {*} videoUrl 视频链接
 * @param {*} frames 帧数
 */
export const getVideoFrame = (videoUrl, frames = 4) => {
  return new Promise((res, err) => {
    const video = document.createElement("video");
    video.width = 270;
    video.height = 162;
    video.src = FILTER_URL() + videoUrl;

    video.currentTime = (1 / 60) * frames;
    video.setAttribute("crossOrigin", "anonymous");
    let base64 = null;
    video.oncanplay = () => {
      const oCanvas = document.createElement("canvas");
      oCanvas.width = video.width;
      oCanvas.height = video.width;
      oCanvas
        .getContext("2d")
        .drawImage(video, 0, 0, video.width, oCanvas.height);

      base64 = oCanvas.toDataURL("image/png");

      // console.log(base64, '图片地址');
      res(base64);
    };
  });
};

// 除法
export const accDiv = (a, b) => {
  let x = 0,
    y = 0,
    a_str = a.toString(),
    b_str = b.toString(),
    a_mul = +a_str.replace(".", ""),
    b_mul = +b_str.replace(".", "");
  try {
    x = a_str.split(".")[1].length;
  } catch (e) {}
  try {
    y = b_str.split(".")[1].length;
  } catch (e) {}
  return (a_mul / b_mul) * 10 ** (y - x);
};

export function base64toFile(dataurl, filename = "图片") {
  //将base64转换为文件;
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function getDuration(millisecond) {
  const hours = Math.floor(millisecond / 3600000)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((millisecond % 3600000) / 60000)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((millisecond % 60000) / 1000)
    .toString()
    .padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}
export const treeLoadValue = (arr, grade = 0, children = []) => {
  if (grade === "flat") {
    arr.map((i) => {
      children.push(i);
      if (
        Array.isArray(i.evaluationTargetListInfoVoList) &&
        i.evaluationTargetListInfoVoList.length
      ) {
        treeLoadValue(i.evaluationTargetListInfoVoList, grade, children);
      }
    });

    return children;
  }

  return arr.filter((i) => {
    if (
      Array.isArray(i.evaluationTargetListInfoVoList) &&
      i.evaluationTargetListInfoVoList.length
    ) {
      i.evaluationTargetListInfoVoList = treeLoadValue(
        i.evaluationTargetListInfoVoList
      );
    }
    return i.targetType == grade;
  });
};

export const box = (
  message = "你确定这样操作吗？",
  callback = [
    () => {
      console.log("确定了");
    },
    () => {
      console.log("取消了");
    },
  ],
  keyType = "警告"
) => {
  const type = {
    警告: "warning",
    错误: "error",
    提示: "info",
    成功: "success",
  };
  ElMessageBox.confirm(message, keyType, {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: type[keyType],
  })
    .then(() => {
      if (Array.isArray(callback)) {
        callback[0]();
      } else {
        !!callback && callback();
      }
    })
    .catch(() => {
      if (Array.isArray(callback)) {
        callback[1]();
      }
    });
};

export const setScTreeValue = (arr, data, queryType) => {
  return arr.map((i) => {
    i.queryType = queryType;
    i.label = i.className ?? i.gradeName ?? i.schoolName ?? i.schoolTypeName;
    i.value = i.classCode ?? i.schoolNum ?? i.schoolType;
    if (!!i.grade && !!i.schoolNum) {
      i.value = i.schoolNum + "-" + i.grade;
    }
    if ("gradeInfoVoList" in i) {
      i.schoolInfoVoList = i.gradeInfoVoList;
    }
    if ("classInfoVoList" in i) {
      i.schoolInfoVoList = i.classInfoVoList;
    }
    if (!!i.schoolInfoVoList?.length) {
      i.schoolInfoVoList = setScTreeValue(
        i.schoolInfoVoList,
        data,
        queryType + 1
      );
    }

    return i;
  });
};
